import { GridLegacy as Grid } from '@mui/material';
import React, { useContext, useEffect, useState } from "react";
import { FormPerfil } from "../../components/form/form-perfil";
import { AxiosInstance, DialogType } from "../../utils/constants";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { CustomDialog } from "../../components/modals/custom-dialog";


export const MiPerfil = ()=>{

    const {dispatch} = useContext( AppContext );
    const [modalQuestion,setModalQuestion] = useState({});

    useEffect(()=>{

    },[]);


    const sendRequest = (values)=>{
        dispatch({
            type: ActionTypes.setLoadingPage,
            data: true
          });
        AxiosInstance.post("sesion/cambiar-clave",values).then(({data})=>{
            if (!data.status ){

                dispatch({
                    type:ActionTypes.setModalInfo,
                    data:{
                        title:"Advertencia",
                        message:data.msg,
                        type:DialogType.peligro,
                        isVisible:true
                    }
                });

            }else{
                dispatch({
                    type:ActionTypes.setModalInfo,
                    data:{
                        title:"Cambio exitoso",
                        message:"Su contraseña ha sido cambiada con exito",
                        type:DialogType.exitoso,
                        isVisible:true
                    }
                });

            }
    }).catch(error=>{

        dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });

    }).finally(()=>{
        dispatch({
            type: ActionTypes.setLoadingPage,
            data: false
          });
    });
    }

    const onSendPasswordChange = (values)=>{
       
          setModalQuestion({
            isOpened:true,
            title:"Confirmar cambio",
            content:"¿ Esta seguro que desea cambiar la contraseña?, Se cerrarán todas las sesion que tenga activa.",
            actions:[
                {
                    buttomProps:{
                        size:"small",
                        variant:"contained",
                        color:"primary",
                        onClick:()=>setModalQuestion({})
                    },
                    title:"NO"
                },
                {
                    buttomProps:{
                        size:"small",
                        variant:"contained",
                        color:"secondary",
                        onClick:()=>{
                            sendRequest(values);
                            setModalQuestion({});
                        }
                    },
                    title:"SI"
                }
            ]
          });

    }

    return (
        <>
        <CustomDialog {...modalQuestion} />
        <Grid container >
            
            <Grid item sm={2} xs={2} md={3}   >

            </Grid>
            <Grid item sm={8} xs={8} md={6}   >

                <FormPerfil
                isOpened={true}
                onSendData={onSendPasswordChange}
                 />
            </Grid>
            <Grid item sm={2} xs={2} md={3}   >

            </Grid>

        </Grid>
        </>
    )
}